module.exports = __webpack_public_path__ + "static/media/ipad_pro_3.5eeecfaf.png";